import React from 'react';
import classNames from 'classnames';
import translate from '@/lib/intl/translate';

export default function DataListTableHeader({
  className,
  count,
  text,
}: {
  className?: string;
  count?: number;
  text: string;
}) {
  return (
    <div className={classNames(className, 'flex items-center')}>
      <h2 className="type-h3">
        {translate(text, {
          count: count ?? '-',
        })}
      </h2>
    </div>
  );
}
